import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export default function CertificateVerify() {
  const { token } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API}/academy/verify-certificate/${token}`);
        if (!res.ok) { setError('Certificate not found or invalid verification link.'); setLoading(false); return; }
        setResult(await res.json());
      } catch (e) { setError('Failed to verify certificate.'); }
      setLoading(false);
    })();
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 36, maxWidth: 480, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🏆</div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#1a1a2e' }}>Certificate Verification</h2>
        </div>

        {loading && <div style={{ textAlign: 'center', color: '#6b7280' }}>Verifying...</div>}

        {!loading && error && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 10 }}>❌</div>
            <div style={{ color: '#ef4444', fontWeight: 600 }}>{error}</div>
          </div>
        )}

        {!loading && result && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              {result.valid ? (
                <>
                  <div style={{ fontSize: 32, marginBottom: 6 }}>✅</div>
                  <div style={{ color: '#10b981', fontWeight: 700, fontSize: 16 }}>Valid Certificate</div>
                </>
              ) : (
                <>
                  <div style={{ fontSize: 32, marginBottom: 6 }}>⚠️</div>
                  <div style={{ color: '#ef4444', fontWeight: 700, fontSize: 16 }}>This certificate is {result.status}</div>
                </>
              )}
            </div>
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 16 }}>
              <Row label="Certificate Number" value={result.certificate_number} />
              <Row label="Student Name" value={result.student_name} />
              <Row label="Bootcamp Type" value={result.bootcamp_type} />
              <Row label="Cohort" value={result.cohort} />
              <Row label="Certificate Type" value={result.certificate_type} />
              <Row label="Issue Date" value={result.issue_date} />
              <Row label="Status" value={result.status} last />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ label, value, last }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: last ? 'none' : '1px solid #f3f4f6' }}>
      <span style={{ fontSize: 12, color: '#9ca3af', fontWeight: 600, textTransform: 'uppercase' }}>{label}</span>
      <span style={{ fontSize: 13, color: '#1a1a2e', fontWeight: 500 }}>{value ?? '—'}</span>
    </div>
  );
}
